import type {WorkSummary} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import {MainTitlesCell} from 'schemas/renderers/MainTitlesCell';
import {OtherTitles} from 'schemas/renderers/table';
import {Dewey} from '../../renderers';
import {workSummaryDefaultColumns} from './columns/workSummaryDefaultColumns';
import {workTableConfig} from './workTableConfig';

export const workSummaryTableConfig: TableConfiguration<WorkSummary> = {
  ...workTableConfig,
  defaultColumns: workSummaryDefaultColumns,
  partValueRenderers: {
    ...workTableConfig.partValueRenderers,
    mainTitles: MainTitlesCell,
    otherTitles: OtherTitles,
    dewey: Dewey,
  },
};
